export default from './Tabs';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Tabs/index.js